import React, { useContext, useEffect, useState } from "react";
import FormDataContext from "../../Contexts/FormData.context";
import InputCheckbox from "../Shared/FormInputs/InputCheckbox";
import InputDate from "../Shared/FormInputs/InputDate";
import InputDateTime from "../Shared/FormInputs/InputDateTime";
import InputRadio from "../Shared/FormInputs/InputRadio";
import InputSelect from "../Shared/FormInputs/InputSelect";
import InputText from "../Shared/FormInputs/InputText";
import InputCurrency from "../Shared/FormInputs/InputCurrency";
import InputTextArea from "../Shared/FormInputs/InputTextArea";
import {
  DEFAULT_VALUE,
  DEFAULT_VALUE_SELECT,
  formActionEnum,
  jsonKeyMapping,
} from "../../Config/Constants";
import * as _ from "lodash";
import { DYNAMIC_INSERT_FLAG } from "../../environment";
import { TemplateObject } from "../../Models/TemplateObject";
import InputInformation from "../Shared/FormInputs/InputInformation";
import { InputContextProvider } from "../../Contexts/Input.Context";
import { useParams } from "react-router-dom";
import renderFormData from "../../Util/RenderFormData";
import { calculateListItem } from "../../Util/calculationHelper";
import InputHeading from "../Shared/FormInputs/InputHeading";

type Props = {
  formGroup: TemplateObject;
  // optional override: when rendering inside modal we may want to target a step
  // that differs from the URL slug (eg. review-summary uses its own slug).
  stepSlugOverride?: string;
  hasParent?: TemplateObject; // Form Element with parent Form Element
  stepDetails?: TemplateObject; // Step Details
  fieldIndex?: any;
  groups?: any;
  setActiveFieldIndex?: (index: number) => void;
  activeFieldIndex?: number;
  disableAutoAdvance?: boolean;
  /* Single Field Mode */
  singleFieldMode?: boolean; // when true only one field from formGroup is rendered
  singleFieldIndex?: number; // index of the field to render (0-based)
};

const FormBuilder = ({
  formGroup,
  hasParent,
  stepDetails,
  fieldIndex,
  groups,
  setActiveFieldIndex,
  activeFieldIndex,
  stepSlugOverride,
  disableAutoAdvance,
  singleFieldMode = false,
  singleFieldIndex = 0,
}: Props) => {
  const { state, dispatch } = useContext(FormDataContext);
  let { formData } = state;
  const { stepName } = useParams();
  // Determine the effective step slug: prefer override when provided (modal usage)
  const effectiveStepName = stepSlugOverride || stepName;
  const [salesTaxPercentage, setSalesTaxPercentage] = useState(""); // State to store sales tax percentage

  const setFormContextData = (
    id: string,
    value: any,
    inputValue?: string,
    inputType?: string,
    startsWith?: string,
    startsWithKey?: string,
    inputFieldSeparator?: string,
    prefillInputVal?: string
  ) => {
    // Save elementId and Value in FormData Context
    const formElementData: TemplateObject = {
      [id]: value,
    };
    /* Input Radio/Input Check changes */
    if (
      inputValue &&
      _.has(formData, `meta-data-${id}`) &&
      inputType != "checkbox"
    ) {
      const selectedValues = formData[`meta-data-${id}`].values.map(
        (id: string) => {
          /* CHANGE FROM LABEL TO VALUE */
          if (id === value) {
            return {
              id,
              style: "",
            };
          }
          return {
            id,
            style: "none",
          };
        }
      );
      var isAddMore =
        selectedValues.filter(function (item: any) {
          let modifiedId = `${id}` + jsonKeyMapping.CHECKBOX_ADD_MORE_INPUT;
          return (
            item.id?.toLocaleLowerCase().replace(/\s/g, "") ===
            modifiedId.toLocaleLowerCase()
          );
        }).length > 0;
      if (isAddMore) {
        let modifiedId = `${id}` + jsonKeyMapping.CHECKBOX_ADD_MORE_INPUT;
        if (
          value.toLocaleLowerCase().replace(/\s/g, "") ===
          modifiedId.toLocaleLowerCase()
        ) {
          formElementData[`${id}-addmoreToggle`] = "";
        } else {
          formElementData[`${id}-addmoreToggle`] = value;
        }
      }
      formElementData[`meta-data-${id}`] = {
        ...formData[`meta-data-${id}`],
        selectedValues,
      };
    }
    if (inputType === "checkbox") {
      let modifiedValues: any = [];
      let modifiedAddYourOwnValues: any = [];
      const selectedValues = formData[`meta-data-${id}`].values.map(
        (id: string) => {
          /* CHANGE FROM LABEL TO VALUE */
          var found =
            value.filter(function (item: any) {
              return item === id;
            }).length > 0;
          if (found) {
            modifiedValues.push(id);
            return {
              id,
              style: "",
            };
          }
          return {
            id,
            style: "none",
          };
        }
      );
      if (formElementData.hasOwnProperty(id)) {
        if (formElementData[id].length > 0) {
          formElementData[id] = modifiedValues;
        }
      }
      let checkboxId = `${id}` + jsonKeyMapping.CHECKBOX_ADD_MORE_INPUT;
      if (
        selectedValues.filter(function (item: any) {
          return (
            item.id?.toLocaleLowerCase().replace(/\s/g, "") ===
            checkboxId.toLocaleLowerCase()
          );
        }).length > 0
      ) {
        var filteredAraay = modifiedValues.filter(function (e: any) {
          return (
            e.toLocaleLowerCase().replace(/\s/g, "") !==
            checkboxId.toLocaleLowerCase()
          );
        });
        modifiedAddYourOwnValues = filteredAraay;
        formElementData[`${id}-${jsonKeyMapping.CHECKBOX_ADD_MORE_INPUT}`] =
          modifiedAddYourOwnValues;
        var addmoreValue = selectedValues.filter(function (item: any) {
          return (
            item.id?.toLocaleLowerCase().replace(/\s/g, "") ===
            checkboxId.toLocaleLowerCase()
          );
        });
        if (addmoreValue[0].style == "") {
          formElementData[`${id}-addmoreToggle`] =
            jsonKeyMapping.CHECKBOX_ADD_MORE_INPUT;
        } else {
          formElementData[`${id}-addmoreToggle`] = " ";
        }
        formElementData[`${id}iscomma`] =
          modifiedValues.length > 1 ? ", " + "" : "";
      }
      formElementData[`meta-data-${id}`] = {
        ...formData[`meta-data-${id}`],
        selectedValues,
      };
    }
    let isRadioOrCheckbox = false;
    if (inputType === "radio" || inputType === "checkbox") {
      isRadioOrCheckbox = true;
    }
    /* METADATA ADD FOR : FORM ELEMENT WITH CHILDREN FORM ELEMENTS/SPECIAL CASE */
    if (!isRadioOrCheckbox) {
      if (hasParent) {
        const key = `meta-data-${id}`;
        //const key = `${id}`
        if (_.has(formData, key)) {
          const selectedValues = formData[key] || {};
          // formElementData[key] = { ...formData[key], ...selectedValues, ...hasParent }
          formElementData[key] = selectedValues;
        } else {
          // formElementData[key] = hasParent
          formElementData[key] = formElementData[id];
        }
      }
    }
    if (inputType === "radio" && !!formData[`meta-data-txt${id}`]) {
      let calId = `txt${id}`;
      let updatedVal = 0;
      if (value === id + "No") {
        if (calId === formData[`meta-data-txt${id}`].discount) {
          formElementData[formData[`meta-data-txt${id}`].discount] = 0;
        }
        updatedVal = 0;
      } else {
        updatedVal = Number(formData[calId]);
      }
      calculateListItem(formElementData, `txt${id}`, updatedVal, formData);
    }

    if (inputType === "text") {
      if (startsWith !== "") {
        formElementData[`${startsWithKey}startsWith`] = startsWith;
      } else {
        if (!!formData[`${startsWithKey}startsWith`]) {
          formElementData[`${startsWithKey}startsWith`] = " ";
        }
      }
      if (inputFieldSeparator !== "") {
        formElementData[`${startsWithKey}inputFieldSeparator`] =
          inputFieldSeparator;
      } else {
        if (!!formData[`${startsWithKey}inputFieldSeparator`]) {
          formElementData[`${startsWithKey}inputFieldSeparator`] = " ";
        }
      }
      calculateListItem(formElementData, id, value, formData);
      if (prefillInputVal !== "") {
        let modVal = value.replace(prefillInputVal, "");
        formElementData[`${id}`] =
          modVal !== "" ? prefillInputVal + modVal : "";
      }
    }
    dispatch({ type: formActionEnum.SET_FORM_DATA, payload: formElementData });
  };
  /* REMOVE PREVIOUS SELECTED VALUES BASED SELECTED VALUES */
  useEffect(() => {
    const keys = [];
    for (const key in formData) {
      if (key.match("meta-data-")) {
        // eslint-disable-next-line no-unused-vars
        const [_key, elementID] = key.split("meta-data-");
        const metaDataObject = formData[key];
        const id = metaDataObject.id;
        const value = metaDataObject.label;
        const showElement = metaDataObject.showElement;
        const checkboxAddYour = metaDataObject.checkboxAddYour;
        const separator = metaDataObject.separator;

        /* Checkbox : Add Your Own */
        if (checkboxAddYour === true) {
          const checkboxAddYourParent =
            formData[`meta-data-${id}`]?.checkboxAddYour;
          /* skip don't depend input text */
          if (checkboxAddYourParent === true) continue;
          if (checkboxAddYourParent === false) {
            keys.push(key);
            keys.push(elementID);
          }
        }

        /* Array Data type case handled */
        if (
          formData[id] !== undefined &&
          ((formData[id].constructor.name === "Array" &&
            !formData[id].includes(value)) ||
            (formData[id].constructor.name === "String" &&
              formData[id] !== value))
        ) {
          /* CONDITION ADDED FOR Input text,textarea,date and datetime */
          if (
            (formData[id] !== "" && showElement === DEFAULT_VALUE) ||
            (formData[id] !== "" && showElement === formData[id]) ||
            separator
          ) {
            break;
          }
          /* REMOVE ADD MORE VALUES OF CONDITIONAL BASED INPUT */
          let i = 0;
          const addMoreKeys = [];
          while (formData[`${elementID}${i}`]) {
            addMoreKeys.push(`${elementID}${i}`);
            i++;
          }
          keys.push(key);
          keys.push(elementID);
          keys.push(...addMoreKeys);
        }

        /* delete children if its parent is removed */
        if (keys.includes(id)) {
          keys.push(key);
          keys.push(elementID);
        }
      }
    }
    if (keys.length > 0) {
      dispatch({ type: formActionEnum.REMOVE_FORM_DATA, payload: keys });
    }

    return () => {};
  }, [formData]);

  // Input Change Event Handler
  const handleInputChange = (
    e: HTMLInputElement,
    startsWith: string,
    startsWithKey: string,
    inputFieldSeparator: string,
    prefillInputVal: string
  ) => {
    let event: any = e;
    const inputId = event.target.id;
    const inputValue = event.target.value;
    setFormContextData(
      inputId,
      inputValue,
      undefined,
      event.target.type,
      startsWith,
      startsWithKey,
      inputFieldSeparator,
      prefillInputVal
    );
  };
  const handleDateChange = (id: string, type: string, date: Date | null) => {
    setFormContextData(id, date, undefined, type);
  };
  // TextArea Event Handler
  const handleTextAreaChange: React.ChangeEventHandler<HTMLTextAreaElement> = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {

    const inputId = event.target.id;
    const inputValue = event.target.value;
    setFormContextData(inputId, inputValue, undefined, event.target.type);
  };
  

  // Input Selection Change Event Handler
  const handleSelectInput = (event: TemplateObject, inputId: string) => {
    let inputValue = event.value;
    if (inputValue === DEFAULT_VALUE_SELECT) {
      inputValue = "";
    }
    setFormContextData(inputId, inputValue);
  };

  // Input Radio Click Event Handler
  const handleRadioInput = (inputId: string, label: string, value?: string) => {
    /* CHANGE FROM LABEL TO VALUE */
    // Before updating, determine if we need to clear previously entered "morefields" child inputs
    try {
      const parentElement: any = Array.isArray(formGroup)
        ? formGroup.find((f: any) => f[jsonKeyMapping.FORM_ID] === inputId)
        : null;
      if (parentElement && Array.isArray(parentElement.inputRadio)) {
        // Find selected option (the one the user just clicked)
        const selectedVal = value;
        const selectedOption = parentElement.inputRadio.find(
          (opt: any) => opt.value === selectedVal
        );
        // Collect all possible child field IDs from any option that has morefields
        const allChildIds: string[] = [];
        parentElement.inputRadio.forEach((opt: any) => {
          if (Array.isArray(opt.morefields)) {
            opt.morefields.forEach((mf: any) => {
              if (mf && mf.id) allChildIds.push(mf.id);
            });
          }
        });
        // If the newly selected option does NOT expose morefields, clear all child IDs
        const shouldClearChildren = !(
          selectedOption && Array.isArray(selectedOption.morefields) && selectedOption.morefields.length > 0
        );
        if (shouldClearChildren && allChildIds.length > 0) {
          const removalKeys: string[] = [];
            allChildIds.forEach((cid) => {
              if (formData[cid] !== undefined) removalKeys.push(cid);
              // Also remove any meta-data captured for the child
              if (formData[`meta-data-${cid}`] !== undefined) {
                removalKeys.push(`meta-data-${cid}`);
              }
              // Remove dynamic add more style suffixes if present (cid0, cid1, etc.)
              let dynIndex = 0;
              while (formData[`${cid}${dynIndex}`] !== undefined) {
                removalKeys.push(`${cid}${dynIndex}`);
                dynIndex++;
              }
            });
          if (removalKeys.length > 0) {
            dispatch({ type: formActionEnum.REMOVE_FORM_DATA, payload: removalKeys });
          }
        }
      }
    } catch (e) {
      // swallow errors: non-critical cleanup path
    }
    setFormContextData(inputId, value, label, "radio");
  };

  // Input Checkbox Event Handler
  const handleCheckBoxSelect = (
    inputId: string,
    label: string,
    event: React.ChangeEvent<HTMLInputElement>,
    dynamicInsertFlag: number
  ) => {
    const inputValue = formData[inputId] ? [...formData[inputId]] : [];
    if (dynamicInsertFlag === DYNAMIC_INSERT_FLAG.STATIC) {
      if (event.target.checked && !inputValue.includes(label)) {
        inputValue.push(label);
      } else {
        _.pull(inputValue, label);
      }
    } else {
      if (dynamicInsertFlag === DYNAMIC_INSERT_FLAG.DYNAMIC_INSERT) {
        inputValue.push(label);
      } else {
        _.pull(inputValue, label);
      }
    }
    setFormContextData(inputId, inputValue, label, event.target.type);
  };

  const onBlur = (e: any, label: any, formElement: any) => {
    const isSingleAddMoreParent = formElement.addmore === "yes";
    const isSingleAddMoreChild = formElement.addmore === false;
    const allFormData = { ...formData };
    const index = e.target.title;
    const inputLabel = label.replaceAll(" ", "");
    const currentStep = effectiveStepName || "";
    const inputValue = e.target.value;
    const groupLabel: string[] = [];
    const parentLabelArray: string[] = [];
    let findParentLabel = "";

    groups &&
      groups.forEach((item: any) => {
        if (item.addMoreGroup === "yes") {
          if (item.groupElement) {
            item.groupElement.forEach((group: any) => {
              const inputLabel = group.label.replaceAll(" ", "");
              groupLabel.push(inputLabel);
              if (group.label === label) {
                parentLabelArray.push(...item.groupElement);
              }
            });
          }
        }
      });

    if (parentLabelArray.length > 0) {
      const lastIndex: any = parentLabelArray[parentLabelArray.length - 1];

      if (lastIndex && lastIndex.label) {
        findParentLabel = lastIndex.label.replaceAll(" ", "");
      }
    }

    if (isSingleAddMoreParent || isSingleAddMoreChild) {
      const parentLabel = currentStep + "-" + inputLabel;

      if (allFormData[parentLabel] === undefined) {
        allFormData[parentLabel] = [{ [inputLabel]: inputValue }];
      }

      if (allFormData[parentLabel]) {
        const updateData = [...allFormData[parentLabel]];
        const findIndex = allFormData[parentLabel].findIndex(
          (item: object, i: number) => i === parseInt(index)
        );

        if (findIndex !== -1) {
          updateData[index] = {
            ...updateData[index],
            [inputLabel]: inputValue,
          };
        } else {
          updateData.push({
            [inputLabel]: inputValue,
          });
        }

        allFormData[parentLabel] = updateData;
      }

      dispatch({ type: formActionEnum.SET_FORM_DATA, payload: allFormData });
    }

    if (groupLabel.includes(inputLabel)) {
      const parentLabel = currentStep + "-" + findParentLabel;

      if (allFormData[parentLabel] === undefined) {
        allFormData[parentLabel] = [{ [inputLabel]: inputValue }];
      }

      if (allFormData[parentLabel]) {
        const updateData = [...allFormData[parentLabel]];
        const findIndex = allFormData[parentLabel].findIndex(
          (item: object, i: number) => i === parseInt(index)
        );

        if (findIndex !== -1) {
          updateData[index] = {
            ...updateData[index],
            [inputLabel]: inputValue,
          };
        } else {
          updateData.push({
            [inputLabel]: inputValue,
          });
        }

        allFormData[parentLabel] = updateData;
      }

      dispatch({ type: formActionEnum.SET_FORM_DATA, payload: allFormData });
    }
  };

  // Get components according to formElement data
  // Track and notify parent of field count changes (for Add More)
  useEffect(() => {
    if (
      typeof setActiveFieldIndex === "function" &&
      typeof activeFieldIndex === "number"
    ) {
      // If field count changes and activeFieldIndex is out of bounds, reset to last field
      if (activeFieldIndex >= formGroup.length) {
        setActiveFieldIndex(formGroup.length);
      }
    }
    // eslint-disable-next-line
  }, [formGroup.length]);

  // Helper to wrap focus/interaction events
  // Disable focus-based progress changes; progress is driven solely by filled values
  const handleFieldFocus = (_index: number) => {
    return; // no-op
  };

  // As user types, update activeFieldIndex to the last filled field (0-based)
  useEffect(() => {
    if (disableAutoAdvance) return; // when true the parent (modal) wants to control navigation only
    if (typeof setActiveFieldIndex === "function") {
      // Count the number of fields that have a value (filled fields)
      let filledCount = 0;
      formGroup.forEach((formElement: TemplateObject) => {
        let id = formElement.id || formElement.label || "";
        if (typeof id === "string") {
          id = id.replaceAll(" ", "");
        }
        if (formData[id] !== undefined && formData[id] !== "") {
          filledCount++;
        }
      });
      setActiveFieldIndex(filledCount);
    }
    // eslint-disable-next-line
  }, [formData, formGroup]);

  /* Decide which subset of formGroup to render based on singleFieldMode */
  const effectiveGroup = React.useMemo(() => {
    if (!singleFieldMode) return formGroup;
    if (!Array.isArray(formGroup)) return formGroup;
    if (singleFieldIndex < 0 || singleFieldIndex >= formGroup.length) return [formGroup[0]];
    return [formGroup[singleFieldIndex]];
  }, [formGroup, singleFieldMode, singleFieldIndex]);

  const formDataViews = effectiveGroup.map(
    (formElement: TemplateObject, index: number) => {
      let jsxData = null;
      // Derive a human-friendly slug from the field label or id
      const rawLabel = (formElement[jsonKeyMapping.FORM_LABEL] || formElement[jsonKeyMapping.FORM_ID] || `field-${index}`).toString();
      const baseSlug = rawLabel
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      // Track duplicates per step to ensure unique DOM ids
      // We stash a map on the closure (initialize once)
      // @ts-ignore - attach to function scope via (FormBuilder as any)
      if (!(FormBuilder as any)._fieldSlugCounts) {
        // @ts-ignore
        (FormBuilder as any)._fieldSlugCounts = {};
      }
      // @ts-ignore
      const countsMap: Record<string, number> = (FormBuilder as any)._fieldSlugCounts;
      const stepKeyForCounts = effectiveStepName || 'global';
      const compoundKey = stepKeyForCounts + '::' + baseSlug;
      const currentCount = countsMap[compoundKey] || 0;
      countsMap[compoundKey] = currentCount + 1;
      const dedupeSuffix = currentCount > 0 ? `-${currentCount + 1}` : '';
      const fieldDomId = `field-${stepKeyForCounts}-${baseSlug}${dedupeSuffix}`;
      const dataFieldSlug = `${baseSlug}${dedupeSuffix}`;
      const internalId = formElement[jsonKeyMapping.FORM_ID];
      // sanitize class tokens to avoid spaces or unsafe characters
      const sanitizedInternalId = internalId
        ? internalId.toString().trim().replace(/\s+/g, "-")
        : "";
      const sanitizedStepKey = stepKeyForCounts.toString().trim().replace(/\s+/g, "-");
      const focusProps = {
        // When singleFieldMode is active, preserve original index semantics for progress logic by
        // mapping the visible field back to its absolute index.
        onFocus: () => handleFieldFocus(singleFieldMode ? singleFieldIndex : index),
        onClick: () => handleFieldFocus(singleFieldMode ? singleFieldIndex : index), // for selects/radios
      };
      switch (formElement[jsonKeyMapping.FORM_TYPE]) {
        case "text":
          jsxData = (
            <InputText
              fieldIndex={fieldIndex}
              formElement={formElement}
              handleInputChange={handleInputChange}
              onBlur={onBlur}
              groups={groups}
              handleDateChange={handleDateChange}
              {...focusProps}
            />
          );
          break;
        case "currency":
          jsxData = (
            <InputCurrency
              fieldIndex={fieldIndex}
              formElement={formElement}
              handleInputChange={handleInputChange}
              onBlur={onBlur}
              groups={groups}
            />
          );
          break;
        case "textarea":
          jsxData = (
            <InputTextArea
              formElement={formElement}
              handleTextAreaChange={handleTextAreaChange}
              {...focusProps}
            />
          );
          break;
        case "select":
          jsxData = (
            <InputSelect
              formElement={formElement}
              handleSelectInput={handleSelectInput}
              {...focusProps}
            />
          );
          break;
        case "date":
          jsxData = (
            <InputDate
              formElement={formElement}
              handleDateChange={handleDateChange}
              {...focusProps}
            />
          );
          break;
        case "datetime":
          jsxData = (
            <InputDateTime
              formElement={formElement}
              handleInputChange={handleInputChange}
              {...focusProps}
            />
          );
          break;
        case "radio":
          jsxData = (
            <InputRadio
              formElement={formElement}
              stepDetail={stepDetails || {}}
              handleRadioInput={handleRadioInput}
              {...focusProps}
            />
          );
          break;
        case "checkbox":
          jsxData = (
            <InputCheckbox
              formElement={formElement}
              handleCheckBoxSelect={handleCheckBoxSelect}
              {...focusProps}
            />
          );
          break;
        case "information":
          jsxData = (
            <InputInformation formElement={formElement} {...focusProps} />
          );
          break;
        case "heading":
          jsxData = <InputHeading formElement={formElement} {...focusProps} />;
          break;
        default:
          jsxData = <></>;
          break;
      }
      return (
        <div
          key={singleFieldMode ? singleFieldIndex : index}
          className={`form-field-wrapper`}
        >
          <InputContextProvider
            initialStepSlug={effectiveStepName}
            disableAutoAdvance={disableAutoAdvance}
          >
            {jsxData}
          </InputContextProvider>
        </div>
      );
    }
  );

  return <>{formDataViews}</>;
};

export default FormBuilder;
